import parse from 'html-react-parser';
import React from 'react';
import { textWrapper } from './Text.module.scss';
import parseLinkOption from '../../utils/LinkUtils';

const Text = ({ textContent, id, pageRef }) => {
  const body = textContent.data.text_content;
  return (
    // We still need triggers and data for the background to help resize the Image backgrounds
    <div
      className={`bgWidthTrigger pagePadding pageGrid sectionVertPadding`}
      data-width="narrow"
    >
      <div className={`gridCenterContent ${textWrapper}`}>
        {parse(body, parseLinkOption)}
      </div>
    </div>
  );
};

export default Text;
